import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import { AppDialogBoxProps } from "../../../interfaces/common/ui/IAppDialogBox";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export const AppDialogBox: React.FC<AppDialogBoxProps> = ({
  title,
  children,
  dialogButtons,
  isDialogOpen,
  handleDialogClose,
  className,
  disableBackdropClick = false,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    handleDialogClose();
  };

  const handleDialogOnClose = (_event: object, reason: string) => {
    if (disableBackdropClick && reason === "backdropClick") {
      return;
    }
    handleClose();
  };

  useEffect(() => {
    setOpen(isDialogOpen);
  }, [isDialogOpen]);

  return (
    <>
      <BootstrapDialog
        maxWidth='md'
        aria-labelledby='customized-dialog-title'
        open={open}
        onClose={handleDialogOnClose}
        className={className}
      >
        {title && (
          <DialogTitle id='customized-dialog-title'>{title}</DialogTitle>
        )}
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 0,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>{children}</DialogContent>
        <DialogActions>{dialogButtons}</DialogActions>
      </BootstrapDialog>
    </>
  );
};
